<template>
    <vx-box color="info"
        class="p-4 lg:px-8 lg:pt-6 lg:pb-8">
        <div class="text-slate-800 font-extrabold pb-4 lg:text-xl">
            Group Access
        </div>

        <vx-tabs v-model="tab" @update:modelValue="tabChange()" :disabled="props.disabled" size="lg" class="mb-4">
            <vx-tab value="filters">Use Filters</vx-tab>
            <vx-tab value="collection">Choose a Collection</vx-tab>
            <vx-tab value="all">All Groups</vx-tab>
        </vx-tabs>

        <div v-if="tab === 'filters'">
            <group-collection-filters v-model="groupFilters" :disabled="props.disabled"></group-collection-filters>
            <vx-alert v-if="!groupFilters.length" class="mt-4" :closeable="false">
                No filters set. All Groups will have access to this template.
            </vx-alert>
        </div>
        <div v-if="tab === 'collection'">
            <select-group-collection size="lg" v-model="groupCollectionId" :disabled="props.disabled"></select-group-collection>
            <vx-alert v-if="!groupCollectionId" class="mt-4" :closeable="false">
                No collection selected. All Groups will have access to this template.
            </vx-alert>
        </div>
        <div v-if="tab === 'all'">
            <vx-alert :closeable="false">
                All Groups will have access to this template.
            </vx-alert>
        </div>

    </vx-box>
</template>

<script setup>
import { VxAlert, VxBox, VxTabs, VxTab } from '@voxie/frontend-components';
import { onMounted, ref } from 'vue';
import SelectGroupCollection from '~/components/general/SelectGroupCollection.vue';
import GroupCollectionFilters from '../settings/teams/group-collections/form/GroupCollectionFilters.vue';

const props = defineProps({
    snippetId: Number,
    disabled: Boolean
});

const groupFilters = defineModel('groupFilters', {
    type: Array,
    get: (v) => v ?? []
});

const groupCollectionId = defineModel('groupCollectionId', {
    type: Number,
    default: undefined,
});

const tab = ref('filters');

onMounted(() => {
    if (!groupFilters.value.length && !groupCollectionId.value) {
        tab.value = !props.snippetId ? 'filters' : 'all';
    } else if (groupCollectionId.value) {
        tab.value = 'collection';
    } else {
        tab.value = 'filters';
    }
});

const tabChange = () => {
    groupFilters.value = [];
    groupCollectionId.value = undefined;
}
</script>
